import {
  Box,
  Grid,
  Button,
  MenuItem,
  TextField,
  Breadcrumbs,
  Link,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { usePurchaseList, useSupplierList } from "api/hooks/inventory";
import { useSelector } from "react-redux";
import moment from "moment";
import AssessmentIcon from "@mui/icons-material/Assessment";
import DownloadIcon from "@mui/icons-material/Download";
import ReportTable, { RRow, RCell } from "components/Tables/ReportTable";

const columns = [
  { label: "No.", width: 50 },
  { label: "Item", width: 100 },
  { label: "Description", width: 100 },
  { label: "Average Cost" },
  { label: "Current Stock" },
  { label: "Discount" },
  { label: "Supplier" },
];

export default function RecievableReport() {
  const navigate = useNavigate();
  const business_branch_id = useSelector((state) => state.authReducer.business_branch_id);
  const { purchaseList, isLoadingPurchaseList, setSupplierFilter } =
    usePurchaseList(1, business_branch_id);
  const { supplierList } = useSupplierList(1, business_branch_id);

  const handleChangeFilter = async (e) => {
    setSupplierFilter(e.target.value);
  };

  return (
    <Box>
      
      <Breadcrumbs sx={{ padding: "20px" }} aria-label="breadcrumb">
        <Link
          underline="hover"
          sx={{ display: "flex", alignItems: "center" }}
          color="inherit"
          onClick={() => navigate("/reports")}
        >
          <AssessmentIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          Reports
        </Link>
        <Typography
          sx={{ display: "flex", alignItems: "center" }}
          color="text.primary"
        >
          <b>Item Purchase Report</b>
        </Typography>
      </Breadcrumbs>
      <Box>
        <Box p="1rem" m="1rem" borderRadius="0.5rem">
          <Grid container spacing={4} className="alignHorizantal">
            <Grid xs={4}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  // m: "4px",
                }}
              >
                <h4>REPORT PERIOD:</h4>

                <TextField
                  label="PERIOD"
                  select
                  defaultValue="THIS WEEK"
                  size="small"
                  onChange={(e) => {
                    handleChangeFilter(e);
                  }}
                  sx={{
                    minWidth: 50,
                    maxWidth: 300,
                    m: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <MenuItem value="THIS WEEK">THIS WEEK</MenuItem>
                  <MenuItem value="TODAY">TODAY</MenuItem>
                  <MenuItem value="THIS MONTH">THIS MONTH</MenuItem>
                  <MenuItem value="CUSTOM">CUSTOM</MenuItem>
                </TextField>
              </Box>
            </Grid>

            <Grid xs={4}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  // m: "4px",
                }}
              >
                <h4>FILTER BY SUPPLIER:</h4>

                <TextField
                  label="SUPPLIERS"
                  select
                  defaultValue="all"
                  size="small"
                  onChange={(e) => {
                    handleChangeFilter(e);
                  }}
                  sx={{
                    minWidth: 50,
                    maxWidth: 300,
                    m: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <MenuItem key={"DEFAULT"} value="all">
                    ALL
                  </MenuItem>
                  {supplierList.map((row, index) => {
                    return (
                      <MenuItem key={index} value={row.id}>
                        {row.name}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </Box>
            </Grid>
            <Grid xs={4} sx={{ textAlign: "right" }}>
              <Button
                variant="contained"
                onClick={() =>
                  navigate("/purchaseForm", { formType: "create" })
                }
                endIcon={<DownloadIcon />}
              >
                EXPORT
              </Button>
            </Grid>
          </Grid>
        </Box>

        <Box>
          <ReportTable
            columns={columns}
            rows={purchaseList}
            loading={isLoadingPurchaseList}
            emptyMessage="No Data found"
            renderRow={(row, index) => (
              <RRow key={row.id} index={index}>
                <RCell>{index + 1}</RCell>
                <RCell>{moment(row.date_added).format("LL")}</RCell>
                <RCell>{row.invoice_number}</RCell>
                <RCell>{row.purchase_date}</RCell>
                <RCell>{row.grand_total}</RCell>
                <RCell>{row.discount}</RCell>
                <RCell>{row.related_supplier.name}</RCell>
              </RRow>
            )}
          />
        </Box>
      </Box>
    </Box>
  );
}
